import { Controller } from "@hotwired/stimulus"

// Live "prix final" for one premium in the (embedded) amendment commissions step.
// final price = base (hidden + non-editable commissions, server-computed) + sum of the editable inputs.
export default class extends Controller {
  static targets = ["amount", "total"]
  static values = { base: Number }

  connect() {
    this.recompute()
  }

  recompute() {
    const sum = this.amountTargets.reduce((acc, input) => acc + (parseFloat(input.value) || 0), 0)
    const total = Math.round((this.baseValue + sum) * 100) / 100

    if (this.hasTotalTarget) this.totalTarget.textContent = this.format(total)
  }

  // Mirror money-rails humanized_money: no decimals when whole, 2 decimals (comma) otherwise.
  format(value) {
    return Number.isInteger(value)
      ? String(value)
      : value.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }
}
